export default __webpack_public_path__ + "static/cursor-385a61cac1434b3cb6f502eaf88afeb6.png";